/**
 * @Author : zhouqinze
 * @Date : 2019-12-28
 * @Version : 1.0
 * @Content : 合作伙伴
 **/
<template>
    <div>
        <div class="aboutComHead">
            <p>合作伙伴</p>
            <p><span></span><span></span></p>
        </div>
        <div class="partnerCon">
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
            <div class="parItem"><div class="icon"></div></div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .aboutComHead{
        width: 5.875rem;
        font-size: 1.4375rem;
        color: #333;
        margin-bottom: .75rem;
        font-weight: bold;
        span{
            display: inline-block;
            width: 50%;
            height: .1875rem;
            background: #018CF4;
        }
        span:last-child{
            background: #ddd;
        }
    }
    .partnerCon{
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        .parItem{
            width: 20%;
            padding:2.5rem 1.25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon{
                width: 100%;
                height: 5.5rem;
                display: block;
                background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/hzhb_logo.png);
                background-repeat: no-repeat;
                background-position: -1.875rem -4.125rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(1),.parItem:nth-child(5),.parItem:nth-child(9){
            padding-left: 0;
        }
        .parItem:nth-child(2){
            .icon{
                background-position: -15rem -4.125rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(3){
            .icon{
                background-position: -28.75rem -4.125rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(4){
            .icon{
                background-position: -42.5rem -4.125rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(5){
            .icon{
                background-position: -55.625rem -4.125rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(6){
            .icon{
                background-position: -1.875rem -17.875rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(7){
            .icon{
                background-position: -15rem -17.875rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(8){
            .icon{
                background-position: -28.75rem -17.875rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(9){
            .icon{
                background-position: -42.5rem -17.875rem;
                // border: 1px dotted #ccc;
            }
        }
        .parItem:nth-child(10){
            .icon{
                background-position: -55.625rem -17.875rem;
                // border: 1px dotted #ccc;
            }
        }
    }
</style>